// extracted by mini-css-extract-plugin
export default {"success":"index_success__zmDEI","fail":"index_fail__wyED5","normal":"index_normal__CH77B"};